import React from 'react'
import { useUserContext } from '../context/AppContext'

const Alert = () => {
    const { alert } = useUserContext()

    if (!alert) {
        return
    }

    return (
        <div className="fixed shadow-2xl animate-slideIn z-[9999] top-5 right-5 ml-5 md:right-10  px-10 py-2 text-sm md:text-lg font-medium text-center bg-white rounded-full border-2 border-orange-600">
            {alert}
        </div>
    )
}

export default Alert